import './ButtonLoader.css'

export default function ButtonWithLoader({
                                             primaryColor = 'var(--primary-color-500)',
                                             secondaryColor = 'var(--primary-color-750)',
                                             accentColor = 'var(--primary-color-650)',
                                             text = 'Submit Now',
                                             type,
                                             onClick,
                                             loading = false
                                         }) {

    return (
      <button
        className="login-button"
        onClick={onClick}
        disabled={loading}
        type={type}
        style={{
          background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}, ${primaryColor})`,
          boxShadow: loading
            ? `var(--primary-shadow-soft)`
            : `var(--primary-shadow-medium), var(--primary-shadow-soft)`,
        }}
      >
        <div className="login-button-shimmer"></div>

        <div className={`login-button-content ${loading ? 'login-button-hidden' : ''}`}>
          <svg className="login-button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
          {text}
        </div>

        {loading && (
          <div className="login-button-loader">
            <div className="login-button-spinner">
              <svg className="login-button-spinner-ring" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="3"
                  fill="none"
                  opacity="0.2"
                ></circle>
                <path fill="currentColor" d="M12 2a10 10 0 0 1 10 10h-3a7 7 0 0 0-7-7V2z"></path>
              </svg>
              <div className="login-button-spinner-dot"></div>
            </div>
          </div>
        )}
      </button>
    );
}
